import { Component, computed, signal } from '@angular/core'

import { FormsModule } from '@angular/forms'
import { LabeledPropertyComponent } from '../labeled-property/labeled-property.component'
import { ModalBodyComponent } from '../modals/modal-body/modal-body.component'
import { ModalFooterComponent } from '../modals/modal-footer/modal-footer.component'
import { ModalHeaderComponent } from '../modals/modal-header/modal-header.component'
import { TBillRetailerUsageOverride, TBillRetailerUsageOverrideUpdateRequest } from '../settlements/tbill-settlements.types'
import { monthOnlyFormat } from 'src/app/shared/utilities/date'
import { NumberInputComponent } from '../number-input/number-input.component'
import { DateDisplayComponent } from '../date-display/date-display.component'

@Component({
  imports: [
    FormsModule,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    LabeledPropertyComponent,
    DateDisplayComponent,
    NumberInputComponent,
  ],
  selector: 'app-update-tbill-retailer-usage-override-modal',
  styles: '',
  template: `
    <div app-modal-header>Update Override</div>

    @if(data()) {
        <div app-modal-body>
            <div app-labeled-property label="Retailer">
                {{ data()!.retailer_code }}
            </div>
            <div app-labeled-property label="Market Interval">          
              <div app-date-display [value]="data()!.market_interval" [format]="monthOnlyFormat"></div>
            </div>
            <div app-labeled-property label="Usage (kW\u00A0h)">
                <div app-number-input [value]="this.modalState().measurement_value ?? 0" (valueChange)="this.updateMeasurementValue($event)"></div>
            </div>
        </div>
    }

    <div app-modal-footer>
        <button
        class="action-btn primary"
        [disabled]="!canUpdate()"
        (click)="update()"
        >
        Update
        </button>
        <button class="action-btn" (click)="onCancel()()">Cancel</button>
    </div>
    `,
})
export class UpdateTBillRetailerUsageOverrideModalComponent {
  protected readonly monthOnlyFormat = monthOnlyFormat

  protected readonly modalState = signal<Partial<{ measurement_value: number }>>({})
  protected readonly data = signal<TBillRetailerUsageOverride | null>(null)
  protected readonly onUpdate = signal<(retailer_uid: string, market_interval: Date, req: TBillRetailerUsageOverrideUpdateRequest) => void>(() => void 0)
  protected readonly onCancel = signal<() => void>(() => void 0)

    
  protected readonly canUpdate = computed(() => {
    return this.data() && 
        (
          !Number.isNaN(this.modalState().measurement_value) &&
            this.modalState().measurement_value !== null &&
            this.modalState().measurement_value !== undefined
        )
  })

  init(overrides: Partial<{
    modalState: Partial<{ measurement_value: number }>,
    data: TBillRetailerUsageOverride,
    onUpdate: (retailer_uid: string, market_interval: Date, req: TBillRetailerUsageOverrideUpdateRequest) => void,
    onCancel: () => void
  }>) {
    this.modalState.update(v => overrides.modalState ?? v)
    this.data.update(v => overrides.data ?? v)
    this.onUpdate.update(v => overrides.onUpdate ?? v)
    this.onCancel.update(v => overrides.onCancel ?? v)
  }

  updateMeasurementValue(measurement_value: number) {
    this.modalState.update(v => ({ ...v, measurement_value }))
  }
  update() {
    this.onUpdate()(
      this.data()!.retailer_uid,
      this.data()!.market_interval,
      {
        measurement_value: this.modalState().measurement_value!,
      },
    )
  }
}
